export const REGISTER_DISPUTE_LOADING = 'REGISTER_DISPUTE_LOADING';
export const REGISTER_DISPUTE_ERROR = 'REGISTER_DISPUTE_ERROR';
export const INITIATE_REGISTER_DISPUTE_APPLICATION_SUCCESS = 'INITIATE_REGISTER_DISPUTE_APPLICATION_SUCCESS';
export const CLEAR_REGISTER_DISPUTE_APPLICATION_ERROR = 'CLEAR_REGISTER_DISPUTE_APPLICATION_ERROR';
export const FETCH_APPLICATION_REGISTER_DISPUTE_SUCCESS = 'FETCH_APPLICATION_REGISTER_DISPUTE_SUCCESS';
export const FETCH_PROPERTY_REGISTER_DISPUTE_SUCCESS = 'FETCH_PROPERTY_REGISTER_DISPUTE_SUCCESS';
export const FETCH_DOCUMENTS_REGISTER_DISPUTE_SUCCESS = 'FETCH_DOCUMENTS_REGISTER_DISPUTE_SUCCESS';
export const SAVE_APPLICATION_REGISTER_DISPUTE_SUCCESS = 'SAVE_APPLICATION_REGISTER_DISPUTE_SUCCESS';
export const CHANGE_REGISTER_DISPUTE_STEP = 'CHANGE_REGISTER_DISPUTE_STEP';
export const REGISTER_DISPUTE_CLEAR_DATA = 'REGISTER_DISPUTE_CLEAR_DATA';
export const DOWNLOAD_DOCUMENT_REGISTER_DISPUTE_SUCCESS = 'DOWNLOAD_DOCUMENT_REGISTER_DISPUTE_SUCCESS';
export const CHECKOUT_REGISTER_DISPUTE_APPLICATION = 'CHECKOUT_REGISTER_DISPUTE_APPLICATION';
export const CHECKOUT_REGISTER_DISPUTE_APPLICATION_SUCCESS = 'CHECKOUT_REGISTER_DISPUTE_APPLICATION_SUCCESS';
export const REGISTER_DISPUTE_CANCEL_APPLICATION_SUCCESS = 'REGISTER_DISPUTE_CANCEL_APPLICATION_SUCCESS';
export const APPROVAL_REGISTER_DISPUTE_SUCCESS = 'APPROVAL_REGISTER_DISPUTE_SUCCESS';
export const POST_RETURN_REGISTER_DISPUTE_SUCCESS = 'POST_RETURN_REGISTER_DISPUTE_SUCCESS';
export const UPLOAD_REGISTER_DISPUTE_DOCUMENT_SUCCESS = 'UPLOAD_REGISTER_DISPUTE_DOCUMENT_SUCCESS';
export const DOWNLOAD_REGISTER_DISPUTE_CONTRACT_DOCUMENT_SUCCESS =
  'DOWNLOAD_REGISTER_DISPUTE_CONTRACT_DOCUMENT_SUCCESS';
// ----------------------------
export const UPDATE_DISPUTE_TYPE_DATA = 'UPDATE_DISPUTE_TYPE_DATA';
export const UPDATE_SELECTED_PROPERTY = 'UPDATE_SELECTED_PROPERTY';
export const UPDATE_MANUAL_ADDRESS = 'UPDATE_MANUAL_ADDRESS';
export const RESET_MANUAL_ADDRESS = 'RESET_MANUAL_ADDRESS';
export const UPDATE_MANUAL_PROPERTIES = 'UPDATE_MANUAL_PROPERTIES';
export const UPDATE_DISPUTE_APPLICATION_DATA = 'UPDATE_DISPUTE_APPLICATION_DATA';
export const UPDATE_DEMANDS_DATA = 'UPDATE_DEMANDS_DATA';
export const GET_MULTIPLE_PROPERTIES = 'GET_MULTIPLE_PROPERTIES';

// Plaintiff & defendants
export const FETCH_PLAINTIFF_SUCCESS = 'FETCH_PLAINTIFF_SUCCESS';
export const FETCH_DEFENDANT_SUCCESS = 'FETCH_DEFENDANT_SUCCESS';
export const UPDATE_PLAINTIFF_DEFENDANT_TYPE = 'UPDATE_PLAINTIFF_DEFENDANT_TYPE';
export const UPDATE_SELECTED_PLAINTIFFS_DEFENDANTS = 'UPDATE_SELECTED_PLAINTIFFS_DEFENDANTS';
export const UPDATE_PLAINTIFFS_DEFENDANTS = 'UPDATE_PLAINTIFFS_DEFENDANTS';
export const REGISTER_DISPUTE_ERROR_IN_MODAL = 'REGISTER_DISPUTE_ERROR_IN_MODAL';
export const REGISTER_DISPUTE_LOADING_IN_MODAL = 'REGISTER_DISPUTE_LOADING_IN_MODAL';
export const REMOVE_PLAINTIFFS_DEFENDANTS = 'REMOVE_PLAINTIFFS_DEFENDANTS';

// Law Firm Information
export const ADD_NEW_LAW_FIRM_INFO = 'ADD_NEW_LAW_FIRM_INFO';
export const DELETE_POA_INFO_ITEM = 'DELETE_POA_INFO_ITEM';
export const UPDATE_POA_INFO_FIELDS = 'UPDATE_POA_INFO_FIELDS';
export const UPDATE_FETCHED_USER = 'UPDATE_FETCHED_USER';
export const FETCH_LOOKUPS_SUCCESS = 'FETCH_LOOKUPS_SUCCESS';
export const ADD_TO_ERROR = 'ADD_TO_ERROR';

export const FETCH_PROPERTY_OWNER_BY_EID_SUCCESS = 'FETCH_PROPERTY_OWNER_BY_EID_SUCCESS';
export const FETCH_REPRESENTATIVE_DETAILS_SUCCESS = 'FETCH_REPRESENTATIVE_DETAILS_SUCCESS';
export const MANUAL_ADDRESS_ADDED_SUCCESS = 'MANUAL_ADDRESS_ADDED_SUCCESS';
export const RESET_PROPERTY_OWNER_BY_EID = 'RESET_PROPERTY_OWNER_BY_EID';
export const UPDATE_REPRESENTATIVE_FETCHED_DATA = 'UPDATE_REPRESENTATIVE_FETCHED_DATA';
export const SET_ACTIVE_UPDATING_LAW_FIRM = 'SET_ACTIVE_UPDATING_LAW_FIRM';
export const SET_ACTIVE_PLAINTIFF_ID = 'SET_ACTIVE_PLAINTIFF_ID';
